module.exports = __webpack_public_path__ + "static/media/at02.f88b4f01.jpg";